import React, { Component } from 'react'
import {
    Container, Row, Col, Spinner
} from 'reactstrap'
import Category from '../productCategory'
import Producto from '../../utils/producto'
import ProductItem from '../../components/productItem'
import ButtonsCategory from '../../components/buttonsCategory'
const prod = new Producto()

export default class Products extends Component {
    constructor() {
        super()
        this.state = {
            categoria: null,
            productos: [],
            categoriaDetalle: '',
            dropdownOpen: false
        }
        this.selectCategoria = this.selectCategoria.bind(this)
        this.onChangeCategoria = this.onChangeCategoria.bind(this)
        this.loadCategoriaDetalle = this.loadCategoriaDetalle.bind(this)
        this.toggleCategorias = this.toggleCategorias.bind(this)
    }

    loadCategoriaDetalle(text) {
        this.setState({
            categoriaDetalle: text
        })
    }

    allProducts() {
        const _this = this
        prod.leerProductos().then(productos => {
            _this.setState({
                productos
            })
            //console.log('prods',productos)
        }).catch(_this.setState({ productos: [] }))
    }

    selectCategoria(e) {
        this.setState({
            categoria: e.target.id
        })
    }

    onChangeCategoria(e){
        console.log(e.target.value)
    }

    componentWillMount() {
        let cat = null
        if (this.props.match) {
            cat = this.props.match.params.categoria
            this.setState({
                categoria: cat
            })
            if (cat)
                return
        }

        this.allProducts()

    }

    toggleCategorias() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    render() {
        window.scrollTo(0, 0)
        return (
            <Container fluid={true} className="Contenedor">
                <Row>
                    <Col sm={8} md={2} lg={2}>
                        <Row>
                            <ButtonsCategory />
                        </Row>
                        {/* <Row>
                            <Col>
                                <p>
                                    Descripcion de categoria:
                            {
                                        this.state.categoriaDetalle
                                    }
                                </p>
                            </Col>

                        </Row> */}
                    </Col>
                    <Col md={9}>
                        {
                            this.props.match.params.categoria ?
                                <Category categoria={this.props.match.params.categoria} loadCategoriaDetalle={this.loadCategoriaDetalle} />
                                :
                                this.state.productos.length === 0 ?
                                <div className="spinnerProductos"><Spinner type="grow" /></div>
                                    :
                                    <Row>
                                        {
                                            this.state.productos.map(p => <Col key={p.id} md={6}><ProductItem key={p.id} product={p} /></Col>)
                                        }
                                    </Row>

                        }
                    </Col>
                </Row>
            </Container>
        )
    }
}